import styled from "@emotion/styled";
import { Avatar, Grid } from "@mui/material";
import { useMemo, useRef, useState } from "react";
import TextSimple from "../../typography/text-simple/TextSimple";
import Location from "@icons-rf/location-icon.svg?react";
import { I_RealestateCard } from "../../../model/interface/realestate-card.interface";
import { useRealestateCardContext } from "../../../context/RealestateCard.context";
import ImprovementsIcons from "./components/improments-icons";
import useCopyToClipboard from "@/shared/hooks/use-copy-to-clipboard";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

export interface IRealEstateCardProps {
  data?: I_RealestateCard;
  useContext?: boolean;
  useCheck?: boolean;
  useMenu?: boolean;
  onChecked?: (e: I_RealestateCard) => void;
  isModal?: boolean;
}

function RealEstateCardMinify(props: IRealEstateCardProps) {
  const { values } = useRealestateCardContext();
  const [value, copy, notification] = useCopyToClipboard();
  const [isHoverImage, setIsHoverImage] = useState(false);
  const imageRef = useRef<HTMLDivElement | null>(null);
  const lateralRef = useRef<HTMLDivElement | null>(null);
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();
  const DATA = useMemo(() => {
    if (props.data && !props.useContext) {
      return props.data;
    } else if (!props.data && props.useContext) {
      return values;
    }
  }, [props]);

  const HandleChecked = (e: any) => {
    if (props.onChecked) {
      props.onChecked(DATA!);
      setIsChecked(!isChecked);
    }
  };

  const handleCopyOnClick = () => {
    copy(DATA!.id + "")
      .then(() => {
        toast.success("Copiado al portapapeles");
      })
      .catch(() => {
        toast.error("Error al copiar");
      });
  };

  return (
    <Content isModal={props.isModal}>
      <ContentFloatRight>
        <Cinta color="transparent"></Cinta>
        <Cinta onClick={handleCopyOnClick} className="pointer">
          <TextSimple
            font="gotham"
            weight="700"
            color="white"
            size="label"
            align="center"
          >
            {`ID: ${DATA!.id}`}
          </TextSimple>
        </Cinta>
      </ContentFloatRight>
      <ContentFloatLeft ref={lateralRef}></ContentFloatLeft>
      <Grid container>
        <Grid item xs={12} mb={-1}>
          <CardImage
            src={DATA?.pictures}
            variant="square"
            className="pointer"
            ref={imageRef}
          />
        </Grid>
      </Grid>
      <ContentInfo container p={2} py={1} pb={0} mt={1}>
        {/* title */}
        <Grid item xs={11.6}>
          <TextSimple
            font="inter"
            weight="bold"
            color="blue"
            size="sub-title"
            truncate={true}
            lineTruncate={2}
          >
            {DATA!.title}
          </TextSimple>
        </Grid>

        <Grid container item xs={12} mt={-1}>
          {DATA!.prices.map(e => (
            <>
              <Grid item xs={12} mb={-1}>
                <TextSimple
                  font="inter"
                  weight="300"
                  color="black"
                  size="description"
                  uppercase={true}
                >
                  {e.label}
                </TextSimple>
              </Grid>
              <Grid item xs={12}>
                <TextSimple font="gotham" weight="700" color="red" size="sub-title">
                  {e.value}
                </TextSimple>
              </Grid>
            </>
          ))}
        </Grid>
        <Grid item>
          <ImprovementsIcons data={DATA?.improvements} />
        </Grid>
        {/* improments */}

        {/* locations */}
        {/* <Grid
          container
          item
          xs={12}
          justifyItems={"center"}
          alignItems={"center"}
          wrap="nowrap"
          spacing={2.5}
        >
          <Grid item xs={0.6}>
            <CustomLocationIcon />
          </Grid>

          <Grid item xs={11.4} mb={0.5}>
            <TextSimple
              font="inter"
              weight="300"
              color="blue"
              size="description"
              capitalize={true}
              truncate={true}
              lineTruncate={1}
            >
              {DATA!.location}
            </TextSimple>
          </Grid>
        </Grid> */}
      </ContentInfo>
    </Content>
  );
}

export default RealEstateCardMinify;

const ImgSize = "11.25rem";

const Content = styled.div((props: { isModal?: boolean }) => {
  const styles = `
    width: 100%;
    overflow: hidden;
    border-radius: 15px;
    position: relative;
    background-color: white;
    min-height: 320px;
    max-height: 360px;
    animation: 0.5s ease-out 0s 1 slideInFromBottom;
    @keyframes slideInFromBottom {
      0% {
        transform: translateY(5%);
      }
      100% {
        transform: translateY(0%);
      }
    }
  `;

  if (props.isModal) {
    return `
      ${styles}
      box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    `;
  }

  return styles;
});

const CardImage = styled(Avatar)`
  width: 100%;
  height: ${ImgSize};
`;

const ContentFloat = `
  position: absolute;
  height: ${ImgSize};
  z-index: 1090;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 6.5rem;
`;

const ContentInfo = styled(Grid)`
  height: calc(100% - ${ImgSize} - 50px);
`;

const ContentFloatRight = styled.div`
  ${ContentFloat}
  right: 0;
`;
const ContentFloatLeft = styled.div`
  ${ContentFloat}
  left: 0;
`;

const Cinta = styled.div<{ color?: string }>`
  width: 100%;
  height: 1.8rem;
  background-color: ${props => props.color ?? "var(--m-color-blue-03)"};
  padding: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  &:nth-of-type(1) {
    border-radius: 0 0 0 0.9375rem;
  }
  &:nth-of-type(2) {
    border-radius: 0.9375rem 0 0 0;
  }
`;

const CustomLocationIcon = styled(Location as any)`
  width: 0.9375rem;
  height: 0.9375rem;
  margin-top: 0.375rem;
  margin-right: 6px;
  color: var(--m-color-red-01);
`;
